import AboutModal from './AboutModal'

export { AboutModal }
